import {
  EnFlagIcon,
  InFlagIcon,
  JaFlagIcon,
  KoFlagIcon,
  MsFlagIcon,
  ThFlagIcon,
  ViFlagIcon,
  ZhFlagIcon,
  TwLanguageIcon,
  FrFlagIcon,
} from '~/assets/icons'

/**
 * Tất cả những gì liên quan đến việc xử lý ngôn ngữ đều phải dựa trên mảng này.
 * Giúp cho việc dynamic sau này chỉ cần sửa 1 chỗ  này
 */
export const baseLanguages = [
  {
    id: 1,
    code: 'ja',
    name: '日本語',
    desc: '使用する言語を選択してください。',
    image: JaFlagIcon,
  },
  {
    id: 2,
    code: 'vi',
    name: 'Tiếng Việt',
    desc: 'Vui lòng chọn một ngôn ngữ để sử dụng.',
    image: ViFlagIcon,
    disabledColor: '#000000',
  },
  {
    id: 3,
    code: 'en',
    name: 'English',
    desc: 'Please select a language to use.',
    image: EnFlagIcon,
  },
  {
    id: 4,
    code: 'ko',
    name: '한국어',
    desc: '사용할 언어를 선택하세요.',
    image: KoFlagIcon,
  },
  {
    id: 5,
    code: 'zh',
    name: '中文',
    desc: '为了您的方便，请选择您优先的语言。',
    image: ZhFlagIcon,
  },
  {
    id: 6,
    code: 'th',
    name: 'Thailand',
    desc: 'กรุณาเลือกภาษาที่จะใช้',
    image: ThFlagIcon,
  },
  {
    id: 7,
    code: 'in',
    name: 'Indonesian',
    desc: 'Please select a language to use.',
    image: InFlagIcon,
  },
  {
    id: 8,
    code: 'ms',
    name: 'Malaysia',
    desc: 'Please select a language to use.',
    image: MsFlagIcon,
  },
  {
    id: 9,
    code: 'zh-TW',
    name: '繁體中文',
    desc: 'Please select a language to use.',
    image: TwLanguageIcon,
  },
  {
    id: 10,
    code: 'fr',
    name: 'Français',
    image: FrFlagIcon,
    desc: 'Veuillez sélectionner une langue à utiliser.',
  },
]

export const listFlagLanguages = baseLanguages.reduce((total, curr) => {
  return {
    ...total,
    [curr.code]: curr.image,
  }
}, {})

export const languageNames = baseLanguages.reduce((total, curr) => {
  return {
    ...total,
    [curr.code]: curr.name,
  }
}, {})

export const languageDesc = baseLanguages.reduce((total, curr) => {
  return {
    ...total,
    [curr.code]: curr.desc,
  }
}, {})
